import {createTheme } from '@mui/material'
import './App.css';
import './index.css';
const theme = createTheme({
 
    palette:
    {
      
      secondary:{
        main: "#FFFFFF", //white
        dark: "#020842",//dark grey
        light: "#0044EB",// blue
        contrastText: "#49515B" //black
      },
      primary:{
        main:"#f44380",//pink
        light:"#E3F0FF",//light blue
        contrastText:"#B6B8CA",
      }
  
    },
    typography:
    {
      fontFamily:'Axiforma, sans-serif',
      h1: {
        fontStyle: 'normal',
        fontWeight: 700,
      },
      h2: {
        fontStyle: 'normal',
        fontWeight: 700,
      },
      h3: {
        fontStyle: 'normal',
        fontWeight: 700,
      },
      h4: {
        fontStyle: 'normal',
        fontWeight: 700,
      },
      h5: {
        fontStyle: 'normal',
        fontWeight: 700,
      },
      h6: {
        fontStyle: 'normal',
        fontWeight: 700,
      },
    },
});

export default theme;